import "core-js/modules/es.array.push.js";
import { Core, Decorative } from "@faire/design-tokens";
import { localizePath } from "@faire/help-center-utils/lib/localization";
import { pageMaxWidthCss } from "@faire/help-center/components/Mixin";
import { Header } from "@faire/help-center/components/PageWrapper/Header/Header";
import { SEOOptimizedHeading } from "@faire/help-center/components/SEOOptimizedHeading";
import { BRANDS_BANNER_DATA, RETAILERS_BANNER_DATA } from "@faire/help-center/consts";
import { trackHelpCenterMakerCardClick } from "@faire/web-api/events/helpCenter/click/makerCard";
import { trackHelpCenterRetailerCardClick } from "@faire/web-api/events/helpCenter/click/retailerCard";
import brands from "@faire/web-api/routes/support/brands";
import retailers from "@faire/web-api/routes/support/retailers";
import { optimizeImageUrl } from "@faire/web/common/images/optimizeImages";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Button } from "@faire/web/slate/Button";
import { Spacer, getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
export var HomeHeader = function HomeHeader(_ref) {
  var loadTimingRef = _ref.loadTimingRef;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  var history = useHistory();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, {
    showSearch: false
  }), /*#__PURE__*/React.createElement(Background, {
    ref: loadTimingRef
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Spacer, {
    height: "5x"
  }), /*#__PURE__*/React.createElement(SEOOptimizedHeading, {
    align: "center"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "TndadM",
    defaultMessage: [{
      "type": 0,
      "value": "Centre d'aide Faire"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "subheadingSansRegular",
    align: "center",
    color: Core.text.subdued
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "FrBXQi",
    defaultMessage: [{
      "type": 0,
      "value": "Comment pouvons-nous vous aider aujourd'hui ?"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "5x"
  }), /*#__PURE__*/React.createElement(CardWrapper, null, /*#__PURE__*/React.createElement(Card, {
    "data-test-id": "help-with-buying-btn",
    onClick: function onClick() {
      trackHelpCenterRetailerCardClick();
      history.push(localizePath(retailers()));
    }
  }, /*#__PURE__*/React.createElement(Banner, {
    alt: RETAILERS_BANNER_DATA(strictLocalize).title,
    src: optimizeImageUrl({
      url: RETAILERS_BANNER_DATA(strictLocalize).imageURL
    }, false, {
      resizeMethod: "fit"
    })
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "pageHeaderSerifRegular",
    align: "center"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "RiQ7vY",
    defaultMessage: [{
      "type": 0,
      "value": "Pour les commerçants"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    color: Core.text.subdued
  }, RETAILERS_BANNER_DATA(strictLocalize).copy), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "LeqJIw",
    defaultMessage: [{
      "type": 0,
      "value": "Aide à l'achat"
    }]
  })))), isMobile ? /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }) : /*#__PURE__*/React.createElement(Spacer, {
    width: "7x"
  }), /*#__PURE__*/React.createElement(Card, {
    onClick: function onClick() {
      trackHelpCenterMakerCardClick();
      history.push(localizePath(brands()));
    },
    "data-test-id": "help-with-selling-btn"
  }, /*#__PURE__*/React.createElement(Banner, {
    alt: BRANDS_BANNER_DATA(strictLocalize).title,
    src: optimizeImageUrl({
      url: BRANDS_BANNER_DATA(strictLocalize).imageURL
    }, false, {
      resizeMethod: "fit"
    })
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "pageHeaderSerifRegular",
    align: "center"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "4EGyPt",
    defaultMessage: [{
      "type": 0,
      "value": "Pour les marques"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    color: Core.text.subdued
  }, BRANDS_BANNER_DATA(strictLocalize).copy), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "iOQvDT",
    defaultMessage: [{
      "type": 0,
      "value": "Aide à la vente"
    }]
  }))))))));
};
var Background = styled.div.withConfig({
  displayName: "HomeHeader__Background"
})(["background-color:", ";"], Decorative.tint.neutral);
var Container = styled.div.withConfig({
  displayName: "HomeHeader__Container"
})(["", " padding:", ";border-bottom:1px solid ", ";", "{padding:", ";}", "{padding:", ";}"], pageMaxWidthCss, getSpacing(0, "3x", "3x"), Core.border.muted, responsiveMediaQueries.tabletAndAbove, getSpacing(0, "5x", "5x"), responsiveMediaQueries.desktopAndAbove, getSpacing(0, "7x", "7x"));
var CardWrapper = styled.div.withConfig({
  displayName: "HomeHeader__CardWrapper"
})(["display:flex;flex-direction:column;align-items:stretch;", "{flex-direction:row;justify-content:center;}"], responsiveMediaQueries.tabletAndAbove);
var Card = styled.div.withConfig({
  displayName: "HomeHeader__Card"
})(["display:flex;flex-direction:column;width:100%;background-color:", ";border:1px solid ", ";cursor:pointer;", "{width:360px;}"], Core.surface.inverse, Core.border.muted, responsiveMediaQueries.tabletAndAbove);
var CardContent = styled.div.withConfig({
  displayName: "HomeHeader__CardContent"
})(["display:flex;flex-direction:column;align-items:center;padding:", ";"], getSpacing("2x", "3x", "4x"));
var Banner = styled.img.withConfig({
  displayName: "HomeHeader__Banner"
})(["width:100%;height:auto;", "{height:208px;}"], responsiveMediaQueries.tabletAndAbove);